import '../../node_modules/@splidejs/splide/dist/css/splide.min.css';
import '../sass/style.scss';
import {Offcanvas} from './offcanvas';
import {SliderManager} from './sliders';

import './custom';

new SliderManager();
// Offcanvas menu
new Offcanvas();
